/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "SHC7cisa4ds", //should be same as youtube video id in url
    title: "Jugaad vs. High Budget Farming | Indian Farmer",
    creator: "Indian Farmer",
    profileUrl:
      "https://yt3.ggpht.com/ytc/AKedOLT6jpVi2qs0FvKHGtIIgoPNownbynnvHSmt-RyMug=s88-c-k-c0x00ffffff-no-rj",
    views: "74461",
    uploadDate: "Sep 28, 2021",
    videoLength: "07:38",
    thumbnailUrl: "https://i3.ytimg.com/vi/SHC7cisa4ds/hq720.jpg",
    thubmnailTitle: "High Budget vs. Low Budget Farming",
    videoUrl: "https://youtu.be/SHC7cisa4ds",
    keywords: ["Budget Farming", "Indian Farmer"],
    categoryName: "Agriculture Tools",
    description: "High Budget vs. Low Budget Farming | Indian Farmer",
  },
  {
    _id: "j8L77seGdSA",
    title:
      "डिजिटल खेती | Fasal Smart Agriculture - The Future of Farming | Agriculture App for Farmers",
    creator: "Indian Farmer",
    profileUrl:
      "https://yt3.ggpht.com/ytc/AKedOLT6jpVi2qs0FvKHGtIIgoPNownbynnvHSmt-RyMug=s88-c-k-c0x00ffffff-no-rj",
    views: "115807",
    uploadDate: "Feb 8, 2020",
    videoLength: "12:35",
    thumbnailUrl: "http://i3.ytimg.com/vi/j8L77seGdSA/hq720.jpg",
    thubmnailTitle: "Smart Farming",
    videoUrl: "https://youtu.be/j8L77seGdSA",
    keywords: ["Smart Farming", "Technology", "Indian Farmer"],
    categoryName: "Technology",
    description: `Fasal is an AI-powered IoT platform for the Agriculture ecosystem that records a 
    variety of growing conditions on the farm. It then uses artificial intelligence and data science to
    make on-farm predictions, before delivering the insights that matter into your hand.`,
  },
  {
    _id: "Tf57e9yjtZQ",
    title:
      "Mango Farming Video  | ऐसे स्मार्ट किसानों के वजह से ही खेती टिकी हुई हैं  ",
    creator: "Indian Farmer",
    profileUrl:
      "https://yt3.ggpht.com/ytc/AKedOLT6jpVi2qs0FvKHGtIIgoPNownbynnvHSmt-RyMug=s88-c-k-c0x00ffffff-no-rj",
    views: "632595",
    uploadDate: "Jun 1, 2021",
    videoLength: "19:52",
    thumbnailUrl: "https://i3.ytimg.com/vi/Tf57e9yjtZQ/hq720.jpg",
    thubmnailTitle: "Mango Farming Techniques",
    videoUrl: "https://youtu.be/Tf57e9yjtZQ",
    keywords: ["Fruit Farming", "Indian Farmer"],
    categoryName: "Fruit Farming",
    description:
      "COMMERCIAL MANGO FARMING PROFIT & MARKETING | Mango Farming Techniques ",
  },
  {
    _id: "IFZqx2KftS4",
    title:
      "Tomato farming | टमाटर की खेती से कमाये लाखो रूपये | टमाटर की खेती | Full Video | A2Z जानकारी",
    creator: "The Advance Agriculture",
    profileUrl:
      "https://yt3.ggpht.com/ytc/AKedOLS5gWmZ5oQtIzXBbWws5TMz8H-xJqKm6BLCZtoQmA=s88-c-k-c0x00ffffff-no-rj",
    views: "2724892",
    uploadDate: "Nov 10, 2020",
    videoLength: "45:39",
    thumbnailUrl: "https://i3.ytimg.com/vi/IFZqx2KftS4/hq720.jpg",
    thubmnailTitle: "Detailed Tomato Farming Technique",
    videoUrl: "https://youtu.be/IFZqx2KftS4",
    keywords: ["Vegetable Farming", "The Advance Agriculture"],
    categoryName: "Vegetable Farming",
    description: "Detailed Tomato Farming Technique ",
  },
  {
    _id: "LW5FCxJkFR0",
    title:
      "Profitable Potato farming 🥔 Seed to harvest | आलू की खेती की पूरी जानकारी",
    creator: "Organic Acre",
    profileUrl:
      "https://yt3.ggpht.com/14HO-rzYU6i9Fdx-GfAcPdhmWTyC2TKJk-9QJhKDm5DalB1HE_O4TeEe3u0HnpkhaqxWsMckLA=s88-c-k-c0x00ffffff-no-rj",
    views: "26382",
    uploadDate: "Jan 24, 2022",
    videoLength: "14:40",
    thumbnailUrl: "https://i3.ytimg.com/vi/LW5FCxJkFR0/hq720.jpg",
    thubmnailTitle: "Detailed Potato Farming Technique",
    keywords: ["Vegetable Farming", "Organic Acre"],
    videoUrl: "https://youtu.be/LW5FCxJkFR0",
    categoryName: "Vegetable Farming",
    description: "Detailed Potato Farming Technique ",
  },
  {
    _id: "Ht7YsLEBfpo",
    title:
      "How to control Thrips & whitefly in Watermelon & Musk Melon Crop | Solomon |Alika |Bio R-303 |tarbuj",
    creator: "The Advance Agriculture",
    profileUrl:
      "https://yt3.ggpht.com/ytc/AKedOLS5gWmZ5oQtIzXBbWws5TMz8H-xJqKm6BLCZtoQmA=s88-c-k-c0x00ffffff-no-rj",
    views: "15952",
    uploadDate: "Mar 15, 2022",
    videoLength: "05:04",
    thumbnailUrl: "https://i3.ytimg.com/vi/Ht7YsLEBfpo/hq720.jpg",
    thubmnailTitle: "control Thrips & whitefly in Watermelon & Musk Melon Crop",
    videoUrl: "https://youtu.be/Ht7YsLEBfpo",
    keywords: ["Pesticides", "Thrips", "Whitefly", "The Advance Agriculture"],
    categoryName: "Pesticides",
    description: "control Thrips & whitefly in Watermelon & Musk Melon Crop ",
  },
  {
    _id: "chEgEGnbaK8",
    title:
      " Israel Technique Avocado Fruit Farming 1200रू Kg बिकने वाले एवोकाडो से कमाये लाखों इजराइल तकनीक से",
    creator: "Farming Leader",
    profileUrl:
      "https://yt3.ggpht.com/kob9_5rTR2E50ah1gynPuJar9wKLz83KvxNFYHMX0QgVgTQbns75egv0fqxQko3FiHb7jUHF9g=s88-c-k-c0x00ffffff-no-rj",
    views: "571389",
    uploadDate: "Mar 27, 2022",
    videoLength: "17:15",
    thumbnailUrl: "https://i3.ytimg.com/vi/chEgEGnbaK8/hq720.jpg",
    thubmnailTitle: "Israel Technique Avocado Fruit Farming",
    videoUrl: "https://youtu.be/chEgEGnbaK8",
    keywords: ["Avocado Farming", "Fruit Farming", "Farming Leader"],
    categoryName: "Fruit Farming",
    description: "Israel Technique Avocado Fruit Farming",
  },
  {
    _id: "OqREBOP7A0I",
    title: "Hydroponic farming | New Business Model | Indian Farmer",
    creator: "Indian Farmer",
    profileUrl:
      "https://yt3.ggpht.com/ytc/AKedOLT6jpVi2qs0FvKHGtIIgoPNownbynnvHSmt-RyMug=s88-c-k-c0x00ffffff-no-rj",
    views: "4530515 ",
    uploadDate: "Feb 8, 2022",
    videoLength: "27:23",
    thumbnailUrl: "http://i3.ytimg.com/vi/OqREBOP7A0I/hq720.jpg",
    thubmnailTitle: "Hydroponic farming | New Business Model | Indian Farmer",
    videoUrl: "https://youtu.be/OqREBOP7A0I",
    keywords: ["Hydroponic Farming", "Vegetable Farming", "Indian Farmer"],
    categoryName: "Hydroponic Farming",
    description: `बिना मिट्टी की खेती के बारे में कभी सुना है?? हां ये possible है। 
    Hydroponic Technology में हम बिना मिट्टी की खेती कर सकते हैं। 
    Hydroponic Farming के बारे में detailed information 
    देखिए इस Indian Farmer video में। 
    Have you ever heard of farming without soil? Yes it is possible. 
    In Hydroponic Technology we can cultivate without soil.
    See detailed information about Hydroponic Farming in this video.`,
  },
  {
    _id: "5AkXl4aD7aU",
    title:
      "What is Hydroponics? History of Hydroponics explained - Merits & Demerits of Hydroponics",
    creator: "Study IQ education",
    profileUrl:
      "https://yt3.ggpht.com/ytc/AKedOLRo9pdG9dMcifqVxtHZjpjOkiXbealcCPFiBCu4yw=s176-c-k-c0x00ffffff-no-rj",
    views: "194624",
    uploadDate: "Jan 6, 2021",
    videoLength: "22:46",
    thumbnailUrl: "http://i3.ytimg.com/vi/5AkXl4aD7aU/hq720.jpg",
    thubmnailTitle: "Vegetable to Grow in May",
    videoUrl: "https://youtu.be/5AkXl4aD7aU",
    keywords: ["Hydroponic Farming", "Vegetable Farming", "Study IQ Education"],
    categoryName: "Hydroponic Farming",
    description: `"Hydroponic Farming by Study IQ Education`,
  },
  {
    _id: "uXzL6iiBass",
    title: "How To Use Nano Urea || Nano Fertilizer || Iffco",
    creator: "Official Farmer",
    profileUrl:
      "https://yt3.ggpht.com/i9aSv9lOG3xa3eQH8ud7Oqr4h1X1HJcvrQk9eVzh2pQz31ww5UEp5UiuowuUVunXnXAALLPLFEU=s176-c-k-c0x00ffffff-no-rj",
    views: "112785",
    uploadDate: "Jun 10, 2021",
    videoLength: "06:02",
    thumbnailUrl: "http://i3.ytimg.com/vi/uXzL6iiBass/hq720.jpg",
    thubmnailTitle: "How to use Nano Urea",
    videoUrl: "https://youtu.be/uXzL6iiBass",
    keywords: ["Nano Urea", "Fertilizers", "Official Farmer"],
    categoryName: "Fertilizers",
    description: `How To Use Nano Urea || Nano Fertilizer || Iffco, full details of Nano Urea Video Use`,
  },
  {
    _id: "B4dgtPwsiII",
    title: "What is NPK Fertilizer, NPK उर्वरक - खाद की पूरी जानकारी",
    creator: "Indian Farmer",
    profileUrl:
      "https://yt3.ggpht.com/ytc/AKedOLT6jpVi2qs0FvKHGtIIgoPNownbynnvHSmt-RyMug=s88-c-k-c0x00ffffff-no-rj",
    views: "228076",
    uploadDate: "Dec 21, 2018",
    videoLength: "10:17",
    thumbnailUrl: "http://i3.ytimg.com/vi/B4dgtPwsiII/hq720.jpg",
    thubmnailTitle: "What is NPK Fertilizer",
    videoUrl: "https://youtu.be/B4dgtPwsiII",
    keywords: ["NPK Fertilizers", "Fertilizers", "Indian Farmer"],
    categoryName: "Fertilizers",
    description: `NPK Fertilizers Ratio, Use, Advantages, Sources, Effects in sabhi ki puri detailed information aapko iss video main milegi. `,
  },
  {
    _id: "KsJocv5q2dE",
    title:
      "May Me konsi Sabji Lagaye | मई में कौन सी सब्जियां उगायें |Vegetable Farming",
    creator: "The Advance Agriculture",
    profileUrl:
      "https://yt3.ggpht.com/ytc/AKedOLS5gWmZ5oQtIzXBbWws5TMz8H-xJqKm6BLCZtoQmA=s88-c-k-c0x00ffffff-no-rj",
    views: "15082",
    uploadDate: "Apr 30, 2022",
    videoLength: "07:09",
    thumbnailUrl: "http://i3.ytimg.com/vi/KsJocv5q2dE/hq720.jpg",
    thubmnailTitle: "How to use Nano Urea",
    videoUrl: "https://youtu.be/KsJocv5q2dE",
    keywords: ["Vegetable Farming", "May", "The Advance Agriculture"],
    categoryName: "Vegetable Farming",
    description: `May Me konsi Sabji Lagaye | मई में कौन सी सब्जियां उगायें | May me lagane Wali sabji |Sabji ki kheti advance agriculture`,
  },
  {
    _id: "zUwYQ7BU1vw",
    title:
      "Agriculture Drone Sprayer | Indian Farmer | 10 एकड़ हो या 100 एकड.....अब स्प्रे का कोई टेंशन नहीं",
    creator: "Indian Farmer",
    profileUrl:
      "https://yt3.ggpht.com/ytc/AKedOLT6jpVi2qs0FvKHGtIIgoPNownbynnvHSmt-RyMug=s88-c-k-c0x00ffffff-no-rj",
    views: "1711703",
    uploadDate: "Sep 17, 2021",
    videoLength: "13:18",
    thumbnailUrl: "http://i3.ytimg.com/vi/zUwYQ7BU1vw/hq720.jpg",
    thubmnailTitle: "Drone Sprayer Review, Price",
    videoUrl: "https://youtu.be/zUwYQ7BU1vw",
    keywords: ["Pesticides", "Technology", "Indian Farmer"],
    categoryName: "Technology",
    description: ` केवल 7-8 मिनट में पूरे एक एकड़ में स्प्रे | टाइम, दवा और मेहनत की बचत | Indian Farmer
      10 एकड़ हो या 100 एकड.....अब स्प्रे का कोई टेंशन नहीं | Agriculture Drone Sprayer Price & Review`,
  },
  {
    _id: "mmKAcyfkN7M",
    title:
      "SOLAR FENCING SYSTEM | Protect your Farm without Killing Animals | Solar fence for Agricultural Land",
    creator: "Discover Agriculture",
    profileUrl:
      "https://yt3.ggpht.com/ytc/AKedOLS-6X_T4AF3-bmg1v6HuOvGxIGL_tR9oNZaZw6Bxw=s176-c-k-c0x00ffffff-no-rj",
    views: "1711703",
    uploadDate: "Sep 17, 2021",
    videoLength: "05:20",
    thumbnailUrl: "http://i3.ytimg.com/vi/mmKAcyfkN7M/hq720.jpg",
    thubmnailTitle: "SOLAR FENCING SYSTEM",
    videoUrl: "https://youtu.be/mmKAcyfkN7M",
    keywords: ["Pesticides", "Technology", "Indian Farmer"],
    categoryName: "Technology",
    description: ` CCM Solar Fencing System (Complete Package)
      * Solar Fencing Guard 45 Acres Capacity
      * Automatic 12+24 hours, with solar attachment
      * Fast charging system
      * Solar panel 12v, 40w
      * Battery 12v,12Amp (with 6 Months Warranty)
      * Corner Insulator  20 pieces  (FREE)
      * Square Insulator (Hook Insulator) 100 pcs (FREE)
      * 1 Year Limited Warranty
      * 2 Years of Spare Support`,
  },
  {
    _id: "VxDIR6wKAfQ",
    title: "Farmers safety shoes | किसानों के सुरक्षा कवच जूते  ",
    creator: "Kisan Farming",
    profileUrl:
      "https://yt3.ggpht.com/2YjxoODi2Q12U9cYX5N9ThqlXOGd7i9tk1MKeDrzM5tHUEcp4YTKvMOpjRh9xCdM0KCqVJuYM4U=s176-c-k-c0x00ffffff-no-rj",
    views: "22048",
    uploadDate: "Oct 1, 2021",
    videoLength: "03:36",
    thumbnailUrl: "http://i3.ytimg.com/vi/VxDIR6wKAfQ/hq720.jpg",
    thubmnailTitle: "Farmers safety shoes",
    videoUrl: "https://youtu.be/VxDIR6wKAfQ",
    keywords: ["Safety Wear", "Shoes", "Kisan Farming"],
    categoryName: "Safety Wear",
    description: `Farmers who are working mostly in the soil mud, it is the best
        option to save their feets from snake bite, insects in soil, sores etc.
        * High quality new PVC material, No recycled material
        * Softness, flexibility, durable and unbreakable
        * Seamless forming, military quality, long wear and no leakage
        * Wear-resisting outsole, anti-slip and shock absorption
        * Not afraid of strong acid and alkali
        * High quality and easy to clean`,
  },
  {
    _id: "B4ImIIo8qt0",
    title: "Natural and Free Best Homemade Organic Insecticide | Pesticides",
    creator: "Indian Farmer",
    profileUrl:
      "https://yt3.ggpht.com/ytc/AKedOLT6jpVi2qs0FvKHGtIIgoPNownbynnvHSmt-RyMug=s88-c-k-c0x00ffffff-no-rj",
    views: "17807",
    uploadDate: "Feb 13, 2021",
    videoLength: "05:23",
    thumbnailUrl: "http://i3.ytimg.com/vi/B4ImIIo8qt0/hq720.jpg",
    thubmnailTitle: "Natural and Free Best Homemade Organic Insecticide",
    videoUrl: "https://youtu.be/B4ImIIo8qt0",
    keywords: ["Pesticides", "Organic", "Indian Farmer"],
    categoryName: "Pesticides",
    description: ` Desi jugaad ke iss video main aaj Brahmastra Organic 
    Insecticide Preparation ghar pe kaise kare iski puri vidhi batayi hai. `,
  },
  {
    _id: "_JHQEELoZio",
    title:
      "How to Prepare Brahmastra - Organic Pesticide? helpful for farmers in agriculture organic farming",
    creator: "Smart Agro",
    profileUrl:
      "https://yt3.ggpht.com/ytc/AKedOLStIwye3nQorl8CkTDMWHqTEbFEX2Non9t2IxPk=s176-c-k-c0x00ffffff-no-rj",
    views: "10906",
    uploadDate: "Sep 5, 2020",
    videoLength: "02:47",
    thumbnailUrl: "http://i3.ytimg.com/vi/_JHQEELoZio/hq720.jpg",
    thubmnailTitle: "Organic Pesticide",
    videoUrl: "https://youtu.be/_JHQEELoZio",
    keywords: ["Pesticides", "Organic", "Smart Agro"],
    categoryName: "Pesticides",
    description: ` This video will explain you process of preparing Brahmastra using organic pesticides.
     One of expert is sharing his tips and tricks which is really helpful for farmers, farmland owners. 
    So please take maximum benefits out of this.  `,
  },
  {
    _id: "Z16eNac_GqY",
    title:
      "Modern Apple Farming | Indian Farmer| ऐसे होती है देवभूमी में Apple की आधुनिक खेती",
    creator: "Indian Farmer",
    profileUrl:
      "https://yt3.ggpht.com/ytc/AKedOLT6jpVi2qs0FvKHGtIIgoPNownbynnvHSmt-RyMug=s88-c-k-c0x00ffffff-no-rj",
    views: "181636",
    uploadDate: "Jan 28, 2022",
    videoLength: "30:41",
    thumbnailUrl: "http://i3.ytimg.com/vi/Z16eNac_GqY/hq720.jpg",
    thubmnailTitle: "Apple Farming",
    videoUrl: "https://youtu.be/Z16eNac_GqY",
    keywords: ["Fruit Farming", "Apple", "Indian Farmer"],
    categoryName: "Fruit Farming",
    description: `Apple Farming कैसे होती है, Apple Farming कहा पे होती है,Traditional Apple Farming कैसे होती है,High Density Apple Farming कैसे करते हैं,सेब की खेती से कितना मुनाफा मिल सकता है,इन सब सवालों के जवाब पाईए इस video में।
      How and where Apple Farming is done, What is Traditional Apple Farming,
      how to do High-Density Apple Farming, how much profit can be made from apple farming,
      get answers to all these questions in this video.`,
  },
  {
    _id: "JHMA7CFI1wk",
    title: "Earth auger । Pit digger । Farming machinery",
    creator: "Kisan Farming",
    profileUrl:
      "https://yt3.ggpht.com/2YjxoODi2Q12U9cYX5N9ThqlXOGd7i9tk1MKeDrzM5tHUEcp4YTKvMOpjRh9xCdM0KCqVJuYM4U=s176-c-k-c0x00ffffff-no-rj",
    views: "896006",
    uploadDate: "Oct 31, 2020",
    videoLength: "08:37",
    thumbnailUrl: "http://i3.ytimg.com/vi/JHMA7CFI1wk/hq720.jpg",
    thubmnailTitle: "Earth auger",
    videoUrl: "https://youtu.be/JHMA7CFI1wk",
    keywords: ["Farming machinery", "Agriculture Tools", "Kisan Farming"],
    categoryName: "Agriculture Tools",
    description: `Earth auger । Pit digger । Farming machinery`,
  },
];
